import { __awaiter } from '../../_virtual/_tslib.js';
import { _global, getGlobalSupport } from '../utils/unils.js';
import { _techReportPb } from './new-report.js';
import { options } from './option.js';
import { mirrorPluginsIns } from './handlePlugin.js';
import { EVENTTYPES } from '../utils/enum.js';
import { HandlerUserReplace } from './handleReplace.js';

var STATUS_CODE;
(function (STATUS_CODE) {
    STATUS_CODE["ERROR"] = "error";
    STATUS_CODE["OK"] = "ok";
})(STATUS_CODE || (STATUS_CODE = {}));
let WHITE_DEBUG = false;
// 白屏检测功能
function openWhiteScreen(whiteConfig) {
    var _a, _b, _c, _d, _e, _f;
    if (whiteConfig === null || whiteConfig === void 0 ? void 0 : whiteConfig.debug) {
        WHITE_DEBUG = true;
        // 创建一个新的 canvas 元素并添加到 body 元素
        var canvas = document.createElement('canvas');
        document.body.appendChild(canvas);
        // 获取 canvas 的 2D 渲染上下文
        var context = canvas.getContext('2d');
        // 设置 canvas 的宽度和高度为当前显示区域的宽度和高度
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        // 设置 canvas 的 CSS 样式为绝对定位
        canvas.style.position = 'absolute';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.zIndex = '9999';
    }
    // 屏幕可是尺寸为0的情况, 也可以用document.visibilityState 和监听 visibilitychange事件，
    // 选项卡来回切换会重复触发,还是选择用视口来作为判断条件
    if (((_b = (_a = _global === null || _global === void 0 ? void 0 : _global.screen) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 0) <= 10 || ((_d = (_c = _global === null || _global === void 0 ? void 0 : _global.screen) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : 0) <= 10)
        return;
    if (((_e = _global === null || _global === void 0 ? void 0 : _global.innerWidth) !== null && _e !== void 0 ? _e : 0) <= 10 || ((_f = _global === null || _global === void 0 ? void 0 : _global.innerHeight) !== null && _f !== void 0 ? _f : 0) <= 10)
        return;
    // const CHECK_DOM_TREE = whiteConfig.checkNum || 3 //基本dom tree结构
    const MAX_LOOP = whiteConfig.maxLoop || 9; // 最大循环次数
    const _checkDomList = whiteConfig.elemArry || whiteConfig.checkDom || ['html', 'body', '#app'];
    const callback = whiteConfig.callback || function () { };
    const _support = getGlobalSupport();
    let _whiteLoopNum = 0; // 循环检测次数
    const _skeletonInitList = []; // 存储初次采样点
    let _skeletonNowList = []; // 存储当前采样点
    let reportWhiteScreenData_ = {}; // 白屏检测点上报
    if (whiteConfig.isSkeleton) {
        // 骨架屏
        if (document.readyState != 'complete') {
            samplePlan();
        }
    }
    else {
        if (document.readyState === 'complete') {
            samplePlan();
        }
        else {
            _global.addEventListener('load', samplePlan);
        }
    }
    // 选中dom点的名称
    function getSelector(element) {
        if (element.id) {
            return '#' + element.id;
        }
        else if (element.className && typeof element.className === 'string') {
            return ('.' +
                element.className
                    .split(' ')
                    .filter((item) => !!item)
                    .join('.'));
        }
        else {
            return element.nodeName.toLowerCase();
        }
    }
    // 判断采样点是否为容器节点
    function isContainer(element) {
        const selector = getSelector(element);
        if (whiteConfig.isSkeleton) {
            _whiteLoopNum ? _skeletonNowList.push(selector) : _skeletonInitList.push(selector);
        }
        // 寻找dom节点匹配,针对
        // selector:'.app.app-warp.app-wrap-list',
        // _checkDomList:['.app-wrap-list']
        // 匹配关系
        let isFindElement = false;
        if (!selector || !_checkDomList)
            return isFindElement;
        for (let i = 0; i <= _checkDomList.length; i++) {
            if (!_checkDomList[i]) {
                continue;
            }
            if (selector.match(_checkDomList[i])) {
                isFindElement = true;
                break;
            }
        }
        return isFindElement;
    }
    function samplePlan() {
        return __awaiter(this, void 0, void 0, function* () {
            // 不支持elementsFromPoint方法
            if (!document || !document.elementsFromPoint) {
                console.warn('当前浏览器不支持elementsFromPoint方法,白屏检测跳过');
                return;
            }
            const pluginWhiteScreenRes = yield mirrorPluginsIns.before(EVENTTYPES.WHITESCREEN);
            if (!pluginWhiteScreenRes)
                return;
            reportWhiteScreenData_['check_list'] = _checkDomList;
            let isEmpty = true; // 初始化白屏值
            // 采样去点逻辑更新,x、y轴各取3个点来做循环判断
            for (let i = 1; i <= 9; i++) {
                const x_x = (_global.innerWidth * i) / 10;
                const x_y = _global.innerHeight / 2;
                const y_x = _global.innerWidth / 2;
                const y_y = (_global.innerHeight * i) / 10;
                const xElements = document.elementsFromPoint(x_x, x_y);
                const yElements = document.elementsFromPoint(y_x, y_y);
                // 检查x轴点
                // 记录坐标点
                const currentX = [];
                if (!reportWhiteScreenData_[`pointX-${x_x}-${x_y}`]) {
                    reportWhiteScreenData_[`pointX-${x_x}-${x_y}`] = [];
                }
                // 调试模式x轴点
                if (WHITE_DEBUG) {
                    drawCircle(x_x, x_y);
                }
                for (let j = 0; j < xElements.length; j++) {
                    currentX.push(getSelector(xElements[j]));
                    if (isContainer(xElements[j])) {
                        isEmpty = false;
                        break;
                    }
                }
                // 记录x轴检查过的节点
                reportWhiteScreenData_[`pointX-${x_x}-${x_y}`] = currentX;
                if (!isEmpty)
                    break;
                // Y轴并且不检测重复的中心点
                if (isEmpty && i != 5) {
                    // 记录坐标点
                    const currentY = [];
                    if (!reportWhiteScreenData_[`pointY-${y_x}-${y_y}`]) {
                        reportWhiteScreenData_[`pointY-${y_x}-${y_y}`] = [];
                    }
                    // 调试模式y轴点
                    if (WHITE_DEBUG) {
                        drawCircle(y_x, y_y);
                    }
                    for (let k = 0; k < yElements.length; k++) {
                        currentY.push(getSelector(yElements[k]));
                        if (isContainer(yElements[k])) {
                            isEmpty = false;
                            break;
                        }
                    }
                    // 记录Y轴检查过的节点
                    reportWhiteScreenData_[`pointY-${y_x}-${y_y}`] = currentY;
                }
                if (!isEmpty)
                    break;
            }
            if (!isEmpty) {
                if (whiteConfig.isSkeleton) {
                    // 第一次不比较
                    if (!_whiteLoopNum)
                        return openWhiteLoop();
                    // 比较前后dom是否一致
                    if (_skeletonNowList.join() == _skeletonInitList.join())
                        return callback({
                            status: STATUS_CODE.ERROR
                        });
                }
                _support._loopTimer && clearTimeout(_support._loopTimer);
                _support._loopTimer = null;
            }
            else {
                openWhiteLoop();
            }
            callback({
                status: isEmpty ? STATUS_CODE.ERROR : STATUS_CODE.OK,
                loop: _whiteLoopNum,
                data: Object.assign({}, reportWhiteScreenData_)
            });
            if (_whiteLoopNum >= MAX_LOOP) {
                // 白屏上报
                _techReportPb({
                    type: 'error',
                    eventId: `${options.origin}.${options.module}.ERROR.whiteScreen`,
                    msg: {
                        // kafka有特殊过滤，需要套一层
                        _BiliCheckDom_Point: Object.assign({}, reportWhiteScreenData_)
                    }
                });
                // 行为日志
                HandlerUserReplace.whiteErrorReplace();
            }
            // 白屏功能结束
            mirrorPluginsIns.after(EVENTTYPES.WHITESCREEN, Object.assign({}, reportWhiteScreenData_));
        });
    }
    function drawCircle(x, y) {
        // 开始一个新的路径
        context.beginPath();
        // 画一个圆
        context.arc(x, y, 10, 0, 2 * Math.PI); // 10 是圆的半径
        // 填充路径
        context.fill();
    }
    // 白屏检测loop
    function openWhiteLoop() {
        if (_whiteLoopNum >= MAX_LOOP && _support._loopTimer) {
            clearTimeout(_support._loopTimer);
            _support._loopTimer = null;
        }
        else {
            _support._loopTimer = setTimeout(() => {
                _whiteLoopNum++;
                if (whiteConfig.isSkeleton) {
                    _skeletonNowList = [];
                }
                samplePlan();
            }, 1000);
        }
    }
}

export { openWhiteScreen };
